import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import WhatsAppWidget from "@/components/site/WhatsAppWidget";
import MobileBottomBar from "@/components/site/MobileBottomBar";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-brand-ice">
      <Header />
      <main className="flex-1 pt-20 pb-20 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppWidget />
      <MobileBottomBar />
    </div>
  );
}
